export default __webpack_public_path__ + "static/media/bin.d14f33f2.svg";